var React = require('react');

function RightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.103848 10.143315l27.585305.225711m0 0l-9.030559 9.351417m9.030559-9.351417l-9.351417-9.030559"}));
}

RightInline.defaultProps = {"width":"29","height":"21","viewBox":"0 0 29 21","fill":"#93897F","stroke":"#93897F","strokeWidth":"2"};

module.exports = RightInline;

RightInline.default = RightInline;
